// Mixins
import { toastMessageMixins } from '@/app/mixins/utils/toast-message-mixins';
import { tableMixins } from '@/app/mixins/utils/table-mixins.js';   
import { userMixins } from '@/app/mixins/modules/user-mixins.js';
import { dateMixins } from '@/app/mixins/utils/date-mixins.js';

// Services
import petService from '@/app/services/main/pets/pets-service.js';

// Third Party libraries
import * as $ from 'jquery';

// Constants
import { STATUS_CODES } from '@/app/constants/status-constants';

export default {
    name: 'modalPetWeight',
    mixins: [
        toastMessageMixins,
        tableMixins,
        userMixins,
        dateMixins
    ],
    data() {
        return {
            isAPILoading: false,
            searchMember: '',
            isGetPetWeightLoading: false,
            tabs: [
                {
                    id: 'myGroups',
                    label: 'My Groups',
                    active: true,
                    memberStatusFilter: 'ACTIVE'
                },
                { 
                    id: 'searchGroups',
                    label: 'Group Search',
                    active: false,
                    memberStatusFilter: 'INACTIVE'
                },
                { 
                    id: 'pendingRequest',
                    label: 'Pending Requests',
                    active: false,
                    memberStatusFilter: 'PENDING'
                }
            ],
            theads: [
                { name: null, sortLabel: null, style: 'width: 20%;'},
                { name: 'Weight', sortLabel: 'weight', isDesc: false, style: 'min-width: 40%;', hasSearch: false},
                { name: 'Date', sortLabel: 'createdAt', isDesc: false, style: 'min-width: 40%;', hasSearch: false}
            ],
            modalContent: {}
        }
    },
    computed: {
        maxWeight() {
            let weight = 0;

            if (this.tableContent.tableData[0] && this.tableContent.tableData[0].breed.maleMaxWeight && this.getActivePet.gender === 'M') {
                weight = this.tableContent.tableData[0].breed.maleMaxWeight;
            }

            if (this.tableContent.tableData[0] && this.tableContent.tableData[0].breed.femaleMaxWeight && this.getActivePet.gender === 'F') {
                weight = this.tableContent.tableData[0].breed.femaleMaxWeight;
            }

            return weight;
        },
        minWeight() {
            let weight = 0;

            if (this.tableContent.tableData[0] && this.tableContent.tableData[0].breed.maleMinWeight && this.getActivePet.gender === 'M') {
                weight = this.tableContent.tableData[0].breed.maleMaxWeight;
            }

            if (this.tableContent.tableData[0] && this.tableContent.tableData[0].breed.femaleMinWeight && this.getActivePet.gender === 'F') {
                weight = this.tableContent.tableData[0].breed.femaleMinWeight;
            }

            return weight;
        },
        overWeight() {
            return parseFloat(this.getActivePet.petWeight) > parseFloat(this.maxWeight);
        },
        underWeight() {
            return parseFloat(this.getActivePet.petWeight) < parseFloat(this.minWeight);
        },
        overWeightText() {
            return this.minWeight === this.maxWeight ? `Overweight. The ideal weight is ${parseFloat(this.minWeight)} kg.` : `Overweight. The ideal weight is between ${parseFloat(this.minWeight)} kg and ${parseFloat(this.maxWeight)} kg.`
        },
        underWeigthText() {
            return this.minWeight < this.maxWeight ? `Underweight. The ideal weight is ${parseFloat(this.minWeight)} kg.` : `Underweight. The ideal weight is between ${parseFloat(this.minWeight)} kg and ${parseFloat(this.maxWeight)} kg.`
        },
        isAddPetWeight() {
            const today = this.formatDate(new Date());
            const dateWeight = this.getActivePet.weightDate ? this.formatDate(this.getActivePet.weightDate) : new Date();
            return today !== dateWeight;
        }
    },
    beforeDestroy() {
        this.closeModal();
    },
    methods: {
        openModal() {
            $(this.$refs.modalPetWeight).modal('show');
            this.columnsFilter = {};
            this.getTableContent();
        },
        closeModal() {
	        $(this.$refs.modalPetWeight).modal('hide');
        },
        getTableContent(fromFilter, page = this.page, limit = this.limit, sortBy = this.sortBy, desc = this.desc) {

            page = fromFilter ? 1 : this.page;
			
			this.getPetWeight({ page, limit, sortBy, desc });
		},
        getPetWeight(queryParams) {

            this.isGetPetWeightLoading = true;
            queryParams['f_petId'] = this.getActivePet.id;
            queryParams.sortBy = 'id'
            queryParams.desc = true;

            petService.getPetWeight(queryParams)
                .then(res => {
                    if (res.status === STATUS_CODES.SUCCESS) {
                        this.tableContent = {
                            tableData: res.data.data,
                            paginationData: res.data.pagination
                        };
                        
                    } else {
                        this.showCustomErrorToast(res.data.errors[0].message, null, true);
                    }
                    this.isGetPetWeightLoading = false;
                })
                .catch(() => {
                    this.isGetPetWeightLoading = false;
                    this.showGenericErrorToast();
                });
        },
        displayWeight(weight) {
            return parseFloat(weight);
        },
        addPetWeight() {
            const modalContent = {
                action: 'Add',
                title: `Add Weight for ${this.getActivePet.name }`,
            }
            this.$emit('addEditPetWeight', modalContent);
        },
        editPetWeight(weight) {
            const modalContent = {
                action: 'Edit',
                title: `Edit ${this.getActivePet.name}'s Weight on ${this.formatDate(weight.createdAt)}`,
                weight,
                page: this.page
            };

            this.$emit('addEditPetWeight', modalContent);
        }
    }
}